import { SxProps, TextField } from '@mui/material';
import { PatternFormat, PatternFormatProps } from 'react-number-format';

import styles from './styles';

const FORMAT = '###-###';
const MASK = '_';
const LABEL = 'Verification Code';

export type VerificationCodeFieldProps = {
  value: string;
  onChange: PatternFormatProps['onValueChange'];
  error?: boolean;
  helperText?: React.ReactNode;
  label?: string;
  fullWidth?: boolean;
  disabled?: boolean;
  sx?: SxProps;
};

const VerificationCodeField: React.FC<VerificationCodeFieldProps> = ({
  value,
  onChange,
  error,
  helperText,
  label = LABEL,
  fullWidth,
  disabled,
  sx,
}) => {
  const handleValueChange: PatternFormatProps['onValueChange'] = (values, sourceInfo) => {
    onChange(values, sourceInfo);
  };

  return (
    <PatternFormat
      customInput={TextField}
      mask={MASK}
      format={FORMAT}
      value={value}
      onValueChange={handleValueChange}
      label={label}
      error={error}
      helperText={helperText}
      fullWidth={fullWidth}
      disabled={disabled}
      valueIsNumericString
      allowEmptyFormatting
      sx={[styles.fieldInput, ...(Array.isArray(sx) ? sx : [sx])]}
    />
  );
};

export default VerificationCodeField;
